module.exports = __webpack_public_path__ + "static/media/logo.b881b3fc.svg";